import "../CSS/uber.css";


function UeberPage() {

    return (

        <>

            {/* ================================= */}
            {/* INTRO */}
            {/* ================================= */}

            <div className="intro">

                <p>
                    Ein paar Worte über mich und meinen Weg zur Tantramassage.
                </p>

            </div>


            <main className="ueber-main">


                {/* ================================= */}
                {/* ÜBER MICH */}
                {/* ================================= */}

                <section className="ueber-einstieg">

                    <figure className="ueber-bild">

                        <img
                            src="/Fotos/meditation_ich.png"
                            alt="Ivan von IRJ-Tantramassagen im Sarganserland"
                        />

                    </figure>


                    <div className="ueber-text">

                        <h1>
                            Ivan – Tantramasseur im Sarganserland
                        </h1>

                        <p>
                            Ich bin Ivan und hinter IRJ-Tantramassagen
                            steht mein persönlicher Weg mit Tantra,
                            achtsamer Berührung und Tantramassage.
                            Mein Angebot im Sarganserland richtet sich
                            auch an Menschen aus Mels, Sargans,
                            Bad Ragaz und der umliegenden Region.
                        </p>

                        <p>
                            Ich beschäftige mich seit mehreren Jahren
                            intensiv mit Tantra und Tantramassage.
                        </p>

                        <p>
                            Was zunächst mit meiner eigenen Erfahrung als
                            Empfänger begann, entwickelte sich mit der Zeit
                            zu einem persönlichen Weg.
                        </p>

                        <p>
                            Dabei durfte ich unterschiedliche Formen der
                            Tantramassage kennenlernen und erfahren, wie
                            unterschiedlich Berührung, Achtsamkeit, Präsenz
                            und Begegnung wirken können.
                        </p>

                        <p>
                            Heute möchte ich diese Erfahrungen nicht mehr
                            nur empfangen, sondern selbst einen Raum schaffen,
                            in dem achtsame Berührung, Vertrauen und Begegnung
                            möglich sind.
                        </p>

                    </div>

                </section>



                {/* ================================= */}
                {/* MEIN WEG */}
                {/* ================================= */}

                <section className="werdegang">

                    <h2>
                        Mein Weg zur Tantramassage
                    </h2>


                    <div className="timeline">


                        {/* 2022 */}

                        <div className="timeline-eintrag">

                            <div className="timeline-jahr">
                                2022
                            </div>

                            <div className="timeline-punkt"></div>

                            <div className="timeline-inhalt">

                                <h3>
                                    Meine erste Begegnung mit Tantramassage
                                </h3>

                                <p>
                                    Meine erste eigene Tantramassage weckte
                                    mein Interesse an dieser Form der achtsamen
                                    Berührung und wurde zum Ausgangspunkt meines
                                    persönlichen Weges.
                                </p>

                            </div>

                        </div>



                        {/* 2022 - 2025 */}

                        <div className="timeline-eintrag">

                            <div className="timeline-jahr">
                                2022–2025
                            </div>

                            <div className="timeline-punkt"></div>

                            <div className="timeline-inhalt">

                                <h3>
                                    Erfahrungen sammeln
                                </h3>

                                <p>
                                    In den folgenden Jahren erhielt ich bei
                                    verschiedenen Anbietern weitere
                                    Tantramassagen.
                                </p>

                                <p>
                                    Dabei lernte ich unterschiedliche
                                    Herangehensweisen kennen und entwickelte
                                    zunehmend ein Gefühl dafür, was achtsame
                                    und respektvolle Körperarbeit für mich
                                    bedeutet.
                                </p>

                            </div>

                        </div>



                        {/* FEBRUAR 2026 */}

                        <div className="timeline-eintrag">

                            <div className="timeline-jahr">
                                Februar 2026
                            </div>

                            <div className="timeline-punkt"></div>

                            <div className="timeline-inhalt">

                                <h3>
                                    Vom Empfangen zum Geben
                                </h3>

                                <p>
                                    Mit dem Besuch des Kurses
                                    «Tantra – was ist das?» begann für mich
                                    ein neuer Abschnitt.
                                </p>

                                <p>
                                    Dabei spürte ich, dass ich Tantra und
                                    achtsame Berührung nicht mehr nur selbst
                                    erfahren, sondern auch anderen Menschen
                                    weitergeben möchte.
                                </p>

                            </div>

                        </div>



                        {/* APRIL 2026 */}

                        <div className="timeline-eintrag">

                            <div className="timeline-jahr">
                                April 2026
                            </div>

                            <div className="timeline-punkt"></div>

                            <div className="timeline-inhalt">

                                <h3>
                                    Entscheidung für die Ausbildung
                                </h3>

                                <p>
                                    Im April 2026 entschied ich mich,
                                    meinen Weg zu vertiefen, und meldete
                                    mich zur Ausbildung zum
                                    <strong> Dipl. Tantramasseur BHS </strong>
                                    bei Body Heart Soul an.
                                </p>

                                <p>
                                    Damit wurde aus meinem Wunsch,
                                    selbst achtsame Berührung weiterzugeben,
                                    ein konkreter nächster Schritt.
                                </p>

                            </div>

                        </div>


                    </div>

                </section>



                {/* ================================= */}
                {/* AUSBILDUNG */}
                {/* ================================= */}

                <section className="ausbildung">

                    <h2>
                        Meine Ausbildung
                    </h2>

                    <p className="ausbildung-status">
                        Ausbildung zum
                        <strong> Dipl. Tantramasseur BHS </strong>
                        bei Body Heart Soul – aktuell in Ausbildung
                    </p>


                    <div className="module">


                        {/* MODUL 1 */}

                        <article className="modul">

                            <div className="modul-nummer">
                                Modul 1
                            </div>

                            <h3>
                                Innere Sicherheit, Grenzen, Präsenz
                                & Nervensystem-Regulation
                            </h3>

                            <p>
                                Im ersten Modul standen ein sicherer und
                                achtsamer Rahmen, das Wahrnehmen und
                                Respektieren von Grenzen sowie die eigene
                                Präsenz im Mittelpunkt.
                            </p>

                            <p>
                                Ein weiterer Schwerpunkt lag auf dem
                                Nervensystem und darauf, wie Sicherheit
                                und Regulation eine vertrauensvolle
                                Begegnung unterstützen können.
                            </p>

                        </article>



                        {/* MODUL 2 */}

                        <article className="modul">

                            <div className="modul-nummer">
                                Modul 2
                            </div>

                            <h3>
                                Sinne, Chakren, Yoga & Meditation
                            </h3>

                            <p>
                                Dieses Modul vertiefte die bewusste
                                Wahrnehmung über die verschiedenen Sinne.
                            </p>

                            <p>
                                Ergänzend beschäftigte ich mich mit
                                Chakren, Yoga und Meditation und damit,
                                wie diese Elemente in die tantrische
                                Körperarbeit einfliessen können.
                            </p>

                        </article>



                        {/* MODUL 3 */}

                        <article className="modul">

                            <div className="modul-nummer">
                                Modul 3
                            </div>

                            <h3>
                                Selbstwahrnehmung, Gefühle
                                & Scham lösen
                            </h3>

                            <p>
                                Im Zentrum standen die eigene Körper-
                                und Selbstwahrnehmung sowie ein bewusster
                                Umgang mit Gefühlen und Scham.
                            </p>

                            <p>
                                Für mich ist dies ein wichtiger Bestandteil,
                                um Menschen offen, wertfrei und mit Respekt
                                begegnen zu können.
                            </p>

                        </article>



                        {/* MODUL 4 */}

                        <article className="modul">

                            <div className="modul-nummer">
                                Modul 4
                            </div>

                            <h3>
                                Berührung jenseits der Technik
                                & Ritualarbeit
                            </h3>

                            <p>
                                Dieses Modul rückte die Qualität der
                                Berührung in den Vordergrund.
                            </p>

                            <p>
                                Nicht allein eine bestimmte Massagetechnik
                                entscheidet über die Begegnung, sondern
                                ebenso Präsenz, Achtsamkeit und die bewusste
                                Gestaltung des Rahmens.
                            </p>

                            <p>
                                Die Ritualarbeit bildete dabei einen
                                weiteren Schwerpunkt.
                            </p>

                        </article>


                    </div>


                    <div className="ausbildung-hinweis">

                        <h3>
                            Mein Ausbildungsweg geht weiter
                        </h3>

                        <p>
                            Ich befinde mich aktuell in der Ausbildung
                            zum Dipl. Tantramasseur BHS bei Body Heart Soul
                            und erweitere und vertiefe meine Kenntnisse
                            und praktische Erfahrung kontinuierlich.
                        </p>

                    </div>

                </section>



                {/* ================================= */}
                {/* MEINE HALTUNG */}
                {/* ================================= */}

                <section className="haltung">

                    <h2>
                        Meine Haltung
                    </h2>


                    <div className="haltung-grid">


                        <article className="haltung-karte">

                            <h3>
                                Achtsamkeit
                            </h3>

                            <p>
                                Bewusste Begegnung und Berührung
                                mit Präsenz und Aufmerksamkeit.
                            </p>

                        </article>


                        <article className="haltung-karte">

                            <h3>
                                Respekt
                            </h3>

                            <p>
                                Bedürfnisse und persönliche Grenzen
                                werden wahrgenommen und respektiert.
                            </p>

                        </article>


                        <article className="haltung-karte">

                            <h3>
                                Vertrauen
                            </h3>

                            <p>
                                Ein geschützter und klarer Rahmen
                                schafft die Grundlage für eine
                                entspannte Begegnung.
                            </p>

                        </article>


                        <article className="haltung-karte">

                            <h3>
                                Offenheit
                            </h3>

                            <p>
                                Wünsche, Bedürfnisse und Grenzen
                                dürfen offen und wertfrei
                                kommuniziert werden.
                            </p>

                        </article>


                    </div>


                    <div className="haltung-abschluss">

                        <p>
                            Für mich beginnt eine achtsame Begegnung
                            mit gegenseitigem Respekt und offener
                            Kommunikation.
                        </p>

                        <p>
                            Deine Bedürfnisse und Grenzen sind ebenso
                            wichtig wie meine eigenen. Deshalb gehört
                            ein persönliches Vorgespräch für mich
                            selbstverständlich dazu.
                        </p>

                    </div>

                </section>



                {/* ================================= */}
                {/* WAS DU BEI MIR ERWARTEN KANNST */}
                {/* ================================= */}

                <section className="erwarten">

                    <h2>
                        Was Du bei mir erwarten kannst
                    </h2>

                    <p className="erwarten-einleitung">
                        Eine Tantramassage beginnt für mich nicht erst mit
                        der Berührung. Ein achtsamer und klarer Rahmen
                        gehört für mich von Anfang an dazu.
                    </p>


                    <div className="erwarten-ablauf">


                        {/* VORGESPRÄCH */}

                        <div className="erwarten-schritt">

                            <div className="erwarten-symbol">
                                01
                            </div>


                            <div className="erwarten-inhalt">

                                <h3>
                                    Vorgespräch
                                </h3>

                                <p>
                                    Vor jeder Massage nehmen wir uns Zeit
                                    für ein persönliches Gespräch.
                                </p>

                                <ul>

                                    <li>
                                        Wir klären Deine Wünsche und
                                        Bedürfnisse.
                                    </li>

                                    <li>
                                        Offene Fragen und Unsicherheiten
                                        haben ihren Platz.
                                    </li>

                                    <li>
                                        Wir sprechen über Deine und
                                        meine Grenzen.
                                    </li>

                                </ul>

                            </div>

                        </div>



                        <div className="erwarten-pfeil">
                            ↓
                        </div>



                        {/* ACHTSAME BEGEGNUNG */}

                        <div className="erwarten-schritt">

                            <div className="erwarten-symbol">
                                02
                            </div>


                            <div className="erwarten-inhalt">

                                <h3>
                                    Achtsame Begegnung
                                </h3>

                                <p>
                                    Während der Massage stehen Achtsamkeit,
                                    Präsenz und gegenseitiger Respekt im
                                    Mittelpunkt.
                                </p>

                                <ul>

                                    <li>
                                        Es gibt keinen Leistungsdruck.
                                    </li>

                                    <li>
                                        Die Berührung findet in einem klar
                                        vereinbarten und respektvollen
                                        Rahmen statt.
                                    </li>

                                    <li>
                                        Du darfst jederzeit kommunizieren,
                                        wenn sich etwas für Dich nicht
                                        stimmig anfühlt.
                                    </li>

                                    <li>
                                        Vereinbarungen und Grenzen dürfen
                                        jederzeit angepasst werden.
                                    </li>

                                </ul>

                            </div>

                        </div>



                        <div className="erwarten-pfeil">
                            ↓
                        </div>



                        {/* NACHRUHE UND ABSCHLUSS */}

                        <div className="erwarten-schritt">

                            <div className="erwarten-symbol">
                                03
                            </div>


                            <div className="erwarten-inhalt">

                                <h3>
                                    Nachruhe & Abschluss
                                </h3>

                                <p>
                                    Auch nach der Massage soll genügend
                                    Zeit bleiben, um die Erfahrung in Ruhe
                                    ausklingen zu lassen.
                                </p>

                                <ul>

                                    <li>
                                        Zeit zum Nachspüren.
                                    </li>

                                    <li>
                                        In Ruhe wieder ankommen.
                                    </li>

                                    <li>
                                        Möglichkeit für einen kurzen
                                        gemeinsamen Austausch.
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </div>



                    {/* ================================= */}
                    {/* PERSÖNLICHER ABSCHLUSS */}
                    {/* ================================= */}

                    <div className="erwarten-abschluss">

                        <h3>
                            Was mir besonders wichtig ist
                        </h3>

                        <p>
                            Für mich bedeutet Tantramassage nicht,
                            einfach einem festen Ablauf zu folgen.
                            Jeder Mensch und jede Begegnung ist anders.
                        </p>

                        <p>
                            Mir ist wichtig, präsent zu sein,
                            wahrzunehmen und einen Rahmen zu schaffen,
                            in dem Du Dich sicher, respektiert und
                            willkommen fühlen kannst.
                        </p>

                    </div>



                    {/* ================================= */}
                    {/* BUTTON ZU DEN ANGEBOTEN */}
                    {/* ================================= */}

                    <div className="erwarten-button-bereich">

                        <a
                            href="/angebote"
                            className="erwarten-button"
                        >
                            Meine Angebote kennenlernen
                        </a>

                    </div>

                </section>


            </main>

        </>

    );

}


export default UeberPage;